import React, { Component, createRef } from "react";
import InventoryServices from "../../services/axioServices/apiServices/InventoryServices.js";
import CommonServices from "../../services/axioServices/apiServices/CommonServices.js";
import SwalServices from "../../services/swalServices/SwalServices.js";
import MultiSelectDropdown from "../../components/dropdown/MultiSelectDropdown.js";
import { CommonValidationMessages } from "../../utils/Messages.js";
import { isValidForm } from "../../utils/validation/CommonValidator.js";
import ValidationText from "../../utils/validation/ValidationText.js";
import moment from "moment";
import * as XLSX from 'xlsx';
import { FinancealYearStartDateEndDate } from "../../utils/FinancialYearStartDateEndDate.js";
import { printFunction } from "../../components/print/printContent.js";
import { getAuthProps } from "../../utils/AuthenticationLibrary.js";

class MaterialWisePurchaseReport extends Component {
  constructor(props) {
    super(props);
    this.printRef = createRef();
    this.inventoryServices = new InventoryServices();
    this.commonServices = new CommonServices();
    this.SwalServices = new SwalServices();
    this.state = {
      companyName: '',
      partyDropdownList: [],
      rawMaterialList: [],
      packingMaterialDropDownList: [],
      totalCount: 0,
      // isAllowforPrintData: false,
      tableStatus: "",
      filterDetails: {
        startDate: '',
        endDate: '',
        materialType: 'Raw Material',
        packageMaterialId: '',
        rawMaterialId: '',
        uom: ''
      },
      purchaseOrderReportList: [],
      typeList: [
        { material: 'Raw Material' },
        { material: 'Packing Material' },
      ],
      validationRules: {
        startDate: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "start date"
            ),
          },
        ],
        endDate: [
          {
            type: "require",
            message: CommonValidationMessages.FieldRequired.replace(
              "{0}",
              "end date"
            ),
          },
        ],
      },
      validState: {
        isValid: true,
        error: {},
      },
    }
  }

  componentDidMount() {
    let dates = FinancealYearStartDateEndDate()
    let filterDetails = this.state.filterDetails
    filterDetails.startDate = dates.startDate
    filterDetails.endDate = dates.endDate
    this.setState({ filterDetails: filterDetails })
    this.getAllPartyDropdown()
    const company = getAuthProps()
    this.setState({ companyName: company?.companyName })
  }


  getAllPartyDropdown = () => {
    this.commonServices.getAllPartyDropdown().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;
        let dropdownItems = res.map((item) => ({
          label: item.partyName,
          value: item._id,
          email: item.email
        }));
        this.setState({ partyDropdownList: dropdownItems }, () => {
          this.getAllRMDropdown()
        });
      } else {
        this.getAllRMDropdown()
        this.SwalServices.Error(response.Message);
      }
    });
  };

  getAllRMDropdown = () => {
    this.commonServices.getAllRMDropdown().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;
        let dropdownItems = res.map((item) => ({
          label: item.rmName,
          value: item._id,
          uom: item.rmUOM
        }));
        this.setState({ rawMaterialList: dropdownItems }, () => {
          this.getAllPackingMaterialDropdown()
        });
      } else {
        this.getAllPackingMaterialDropdown()
        this.SwalServices.Error(response.Message);
      }
    });
  };

  getAllPackingMaterialDropdown = () => {
    this.commonServices.getAllPackingMaterialDropdown().then((response) => {
      if (response.statusCode === 200 && response.responseData != null) {
        let res = response.responseData;
        let dropdownItems = res.map((item) => ({
          label: item.pmName,
          value: item._id,
          uom: item.pmUOM
        }));
        this.setState({ packingMaterialDropDownList: dropdownItems });
      } else {
        this.SwalServices.Error(response.Message);
      }
    });
  };

  resetForm = () => {
    let validState = this.state.validState
    validState.isValid = true;
    validState.error = {};
    let filterDetails = this.state.filterDetails
    filterDetails.startDate = ""
    filterDetails.endDate = ""
    filterDetails.materialType = ""
    filterDetails.packageMaterialId = ""
    filterDetails.rawMaterialId = ""
    filterDetails.uom = ""
    this.setState({ validState: validState, filterDetails: filterDetails, tableStatus: "", purchaseOrderReportList: [], totalCount: 0 }, () => {
      this.getAllPartyDropdown()
    })
  }

  handleChange = (event, name) => {
    let value = event.target.value;
    let details = this.state.filterDetails
    details[name] = value;
    this.setState({ filterDetails: details },
      //    () => {
      //   this.setState({ isAllowforPrintData: false })
      // }
    )
  };

  handleDropdownChange = (e, name) => {
    const value = e.target.value;
    let details = this.state.filterDetails;
    details[name] = value;
    this.setState({ filterDetails: details },
      //   () => {
      //   this.setState({ isAllowforPrintData: false })
      // }
    );
  };

  setFilterParameters = (selected, drpIdentity) => {
    let details = this.state.filterDetails
    details[drpIdentity] = selected.value
    details.uom = selected.uom
    this.setState({ filterDetails: details },
      //    () => {
      //   this.setState({ isAllowforPrintData: false })
      // }
    );
  };

  getAllMaterialWisePurchaseReport = () => {
    let isAllFieldsValidate = this.isAllFieldsValidate()
    if (isAllFieldsValidate) {
      this.setState({ tableStatus: "Loading..." })
      let request = this.state.filterDetails
      this.inventoryServices.getAllMaterialWisePurchaseReport(request).then((response) => {
        if (response.statusCode === 200 && response.responseData != null) {
          if (response.responseData.length === 0) {
            this.setState({ tableStatus: "No Record Found" })
          } else {
            this.setState({ tableStatus: "" })
          }
          let totalCount = response.responseData.length
          this.setState({
            purchaseOrderReportList: response.responseData,
            // isAllowforPrintData: true
            totalCount: totalCount
          })
        } else {
          this.setState({ tableStatus: "" })
          this.SwalServices.Error(response.Message);
        }
      })
    }
  }

  isAllFieldsValidate = () => {
    const newValidState = isValidForm(
      this.state.filterDetails,
      this.state.validationRules,
      this.state.validState
    );
    this.setState({ validState: newValidState });
    return newValidState.isValid
  }

  render() {
    return (
      <div className="materialWisePurReport-page reports-page">
        <div className="item-search !mb-2.5">
          <div className="item-grp flex flex-col gap-3 mb-3.5">
            <div className="item-inner-grp flex gap-2.5 w-full">
              <div className="start-date" style={{ width: "100%" }}>
                <label>Start Date</label>
                <input
                  className={` inputFocus ${this.state.validState?.error?.startDate ? "errorInput" : ""}`}
                  type="date"
                  id="startDate"
                  name="startDate"
                  autoComplete="off"
                  value={this.state.filterDetails.startDate}
                  onChange={(event) =>
                    this.handleChange(event, "startDate")
                  }
                  style={{ width: "100%" }}
                />
                {/* <ValidationText
                  error={this.state.validState.error.startDate}
                /> */}
              </div>
              <div className="end-date" style={{ width: "100%" }}>
                <label>End Date</label>
                <input
                  className={` inputFocus ${this.state.validState?.error?.endDate ? "errorInput" : ""}`}
                  type="date"
                  id="endDate"
                  name="endDate"
                  autoComplete="off"
                  value={this.state.filterDetails.endDate}
                  onChange={(event) =>
                    this.handleChange(event, "endDate")
                  }
                  style={{ width: "100%" }}
                />
                {/* <ValidationText
                  error={this.state.validState.error.endDate}
                /> */}
              </div>
              <div className="material-selector" style={{ width: "100%" }}>
                <label>Material Type</label>
                <select
                  value={this.state.filterDetails.materialType}
                  onChange={(e) =>
                    this.handleDropdownChange(e, "materialType", "FilterDetails")
                  }
                >
                  {this.state.typeList.map((x, key) => (
                    <option key={key} value={x.material}>
                      {x.material}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="dropdown-grp flex gap-2.5 w-full">
              <div className="material-dropdown w-[70%]">
                <label>Material Name</label>
                {this.state.filterDetails.materialType === 'Raw Material' ?
                  <>
                    <MultiSelectDropdown
                      drpIdentity="rawMaterialId"
                      options={this.state.rawMaterialList}
                      closeMenuOnSelect={true}
                      hideSelectedOptions={false}
                      onChange={(selected) =>
                        this.setFilterParameters(selected, "rawMaterialId")
                      }
                      allowSelectAll={false}
                      value={this.state.rawMaterialList.filter(
                        (party) =>
                          party.value === this.state.filterDetails.rawMaterialId
                      )}
                    />
                  </>
                  :
                  <>
                    <MultiSelectDropdown
                      drpIdentity="packageMaterialId"
                      options={this.state.packingMaterialDropDownList}
                      closeMenuOnSelect={true}
                      hideSelectedOptions={false}
                      onChange={(selected) =>
                        this.setFilterParameters(selected, "packageMaterialId")
                      }
                      allowSelectAll={false}
                      value={this.state.packingMaterialDropDownList.filter(
                        (party) =>
                          party.value === this.state.filterDetails.packageMaterialId
                      )}
                    />
                  </>
                }
              </div>
              <div className="end-date w-[30%]">
                <label>UOM</label>
                <input
                  type="text"
                  disabled
                  id="uom"
                  name="uom"
                  autoComplete="off"
                  className="inputFocus disable-input"
                  value={this.state.filterDetails.uom}
                  onChange={(event) =>
                    this.handleChange(event, "uom")
                  }
                  style={{ width: "100%" }}
                />
              </div>

            </div>
          </div>
          <div className="btn-grp mt-[5px]">
            <button className="add-btn" onClick={() => this.getAllMaterialWisePurchaseReport()}>Search</button>
            <button className="cancel-btn" onClick={() => this.resetForm()}>Cancel</button>
            {/* {this.state.isAllowforPrintData ? */}
            {this.state.purchaseOrderReportList && this.state.purchaseOrderReportList.length > 0 ?
              <button className="print-btn" onClick={() => printFunction()}>Print</button>
              : null}
          </div>
        </div>
        <div>
          <p className="mb-[3px] text-[15px] font-medium text-[#474747]" >
            Total Count :- {this.state.totalCount ? this.state.totalCount : 0}
          </p>
        </div>
        <div class="item-listing print:w-full" id="printableArea">
          <div className="hidden print-title print:flex print:justify-between print:items-center">
            <h4 className="text-black font-bold print:!text-[22px] leading-tight">Material Wise Purchase Report</h4>
            <p className="text-black">Material type:- {this.state.filterDetails.materialType}</p>
          </div>
          <div class="itemList-table print:w-full">
            <div class="table-container print:w-full print:!h-full print:!overflow-hidden" style={{ height: "calc(100vh - 280px)" }}>
              <table class="itemList">
                <thead className="print:text-[16px] print:text-black">
                  <tr>
                    <td className="w-[10%] print-w-10">Order No</td>
                    <td className="w-[10%] print-w-10">Order Date</td>
                    <td className="w-[20%] no-print">Party Name</td>
                    <td className="w-[20%] print-w-50">Item Name</td>
                    <td className="w-[10%] print-w-10">Qty</td>
                    <td className="w-[10%] print-w-10">Rate</td>
                    <td className="w-[10%] print-w-10">Amount</td>
                    <td className="w-[10%] no-print">Material Type</td>
                  </tr>
                </thead>
                {/* {this.state.purchaseOrderReportList && this.state.purchaseOrderReportList.length > 0 ?
                  this.state.purchaseOrderReportList.map((details, key) => (
                    <tbody key={key}>
                      <tr>
                        <td>{details.purchaseOrderId.purchaseOrderNo ? details.purchaseOrderId.purchaseOrderNo : ''}</td>
                        <td>{details.purchaseOrderId.purchaseOrderDate ? moment(details.purchaseOrderId.purchaseOrderDate).format('DD MMM yyyy') : ''}</td>
                        <td>{details.purchaseOrderId.partyId.partyName ? details.purchaseOrderId.partyId.partyName : ''}</td>
                        <td>{details.rawMaterialId ? details.rawMaterialId.rmName : details.packageMaterialId.pmName}</td>
                        <td>{details.qty ? details.qty : ''}</td>
                        <td>{details.rate ? details.rate : ''}</td>
                        <td>{details.amount ? details.amount : ''}</td>
                        <td>{details.rawMaterialId ? 'Raw' : 'Packing'}</td>
                      </tr>
                    </tbody>
                  )) :
                  <tbody className="validation-body">
                    <tr>
                      <td
                        colSpan={9}
                        style={{ textAlign: "center", fontSize: "16px" }}
                      >
                        No Records Found
                      </td>
                    </tr>
                  </tbody>
                } */}

                <tbody className="print:!text-[12px] print:text-black">
                  {this.state.purchaseOrderReportList && this.state.purchaseOrderReportList.length > 0 ? (
                    this.state.purchaseOrderReportList.map((details, key) => (
                      <tr key={key}>
                        <td>{details.purchaseOrderId.purchaseOrderNo ? details.purchaseOrderId.purchaseOrderNo : ''}</td>
                        <td>{details.purchaseOrderId.purchaseOrderDate ? moment(details.purchaseOrderId.purchaseOrderDate).format('DD MMM yyyy') : ''}</td>
                        <td className="no-print">{details.purchaseOrderId.partyId.partyName ? details.purchaseOrderId.partyId.partyName : ''}</td>
                        <td>{details.rawMaterialId ? details.rawMaterialId.rmName : details.packageMaterialId.pmName}</td>
                        <td>{details.qty ? details.qty : ''}</td>
                        <td>{details.rate ? details.rate : ''}</td>
                        <td>{details.amount ? details.amount : ''}</td>
                        <td className="no-print">{details.rawMaterialId ? 'Raw' : 'Packing'}</td>
                      </tr>
                    ))
                  ) : this.state.purchaseOrderReportList &&
                    this.state.purchaseOrderReportList.length === 0
                    && this.state.tableStatus !== "" ? (
                    <tr>
                      <td colSpan={8} style={{ textAlign: "center", fontSize: "16px" }}>
                        {this.state.tableStatus}
                      </td>
                    </tr>
                  ) : this.state.purchaseOrderReportList &&
                    this.state.purchaseOrderReportList.length === 0
                    && this.state.tableStatus === "" ? null : ""}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/*----- Print layout -----*/}
        <div className='table-print mt-5 hidden' id="printableArea">
          {/* Header */}
          <div className="print-header">
            <table className="hdr-table">
              <tbody>
                <tr>
                  <td>
                    <div className="co-name">{this.state.companyName}</div>
                    <div className="rpt-sub">Material Wise Purchase</div>
                  </td>
                  <td>
                    <div className="hdr-meta">
                      Material Type: <strong>{this.state.filterDetails.materialType}</strong><br />
                      Date: <strong>{this.state.filterDetails.startDate}</strong> to <strong>{this.state.filterDetails.endDate}</strong>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

            <div className="rule-thick" />
            <div className="rule-thin" />
          </div>


          <div className="print-content">

            {/* <div className="info-row">
                      <div>
                        <span className="info-label">Item Name:</span>
                        <p className="info-value">Paracetamol</p>
                      </div>
                    </div> */}

            {/* Table */}
            <table className="data-tbl">
              <colgroup>
                <col style={{ width: "10%" }} />
                <col style={{ width: "15%" }} />
                <col style={{ width: "30%" }} />
                <col style={{ width: "15%" }} />
                <col style={{ width: "15%" }} />
                <col style={{ width: "15%" }} />
              </colgroup>

              <thead>
                <tr>
                  <th style={{ textAlign: 'left' }}>
                    Order No
                  </th>
                  <th style={{ textAlign: 'left' }}>
                    Order Date
                  </th>
                  <th style={{ textAlign: 'left' }}>
                    Item Name
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    Qty
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    Rate
                  </th>
                  <th style={{ textAlign: 'center' }}>
                    Amount
                  </th>
                </tr>
              </thead>

              <tbody>
                {this.state.purchaseOrderReportList && this.state.purchaseOrderReportList.length > 0 ?
                  this.state.purchaseOrderReportList.map((details, key) => (
                    <tr key={key}>
                      <td style={{ textAlign: 'left' }}>
                        {details.purchaseOrderId.purchaseOrderNo ? details.purchaseOrderId.purchaseOrderNo : ''}
                      </td>
                      <td style={{ textAlign: 'left' }}>
                        {details.purchaseOrderId.purchaseOrderDate ? moment(details.purchaseOrderId.purchaseOrderDate).format('DD MMM yyyy') : ''}
                      </td>
                      <td style={{ textAlign: 'left' }}>
                        {details.rawMaterialId ? details.rawMaterialId.rmName : details.packageMaterialId.pmName}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {details.qty ? details.qty : ''}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {details.rate ? details.rate : ''}
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        {details.amount ? details.amount : ''}
                      </td>
                    </tr>
                  )) : (
                    <tr>
                      <td colSpan="6" style={{ textAlign: 'center' }}>
                        No Data Found
                      </td>
                    </tr>
                  )}
              </tbody>
            </table>
          </div>

          {/* Footer */}
          <div className="print-footer">
            <div className="rule-foot">
              <table className="foot-tbl">
                <tbody>
                  <tr>
                    <td>* System generated report. No signature required.</td>
                    <td style={{ textAlign: "right" }}>
                      Printed: {new Date().toLocaleDateString("en-GB")} {new Date().toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>
      </div>
    );
  }
}
export default MaterialWisePurchaseReport;
